export const Cursor = {
    def: 0,
    grab: 1,
    grabbing: 2,
    pointer: 3
}